/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAdminExternalProjectManagerBackfillDto } from '../models/work-admin-external-project-manager-backfill-dto';
import { WorkAdminExternalProjectManagerBackfillResultDto } from '../models/work-admin-external-project-manager-backfill-result-dto';

@Injectable({ providedIn: 'root' })
export class WorkAdminExternalProjectManagersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview()` */
  static readonly AdminExternalProjectManagersControllerGetGeruestrechnerBackfillPreviewPath = '/v2/admin/external-project-managers/geruestrechner-backfill';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminExternalProjectManagerBackfillDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminExternalProjectManagersService.AdminExternalProjectManagersControllerGetGeruestrechnerBackfillPreviewPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminExternalProjectManagerBackfillDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminExternalProjectManagerBackfillDto> {
    return this.adminExternalProjectManagersControllerGetGeruestrechnerBackfillPreview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminExternalProjectManagerBackfillDto>): WorkAdminExternalProjectManagerBackfillDto => r.body)
    );
  }

  /** Path part for operation `adminExternalProjectManagersControllerApplyGeruestrechnerBackfill()` */
  static readonly AdminExternalProjectManagersControllerApplyGeruestrechnerBackfillPath = '/v2/admin/external-project-managers/geruestrechner-backfill';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminExternalProjectManagersControllerApplyGeruestrechnerBackfill()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminExternalProjectManagersControllerApplyGeruestrechnerBackfill$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminExternalProjectManagerBackfillResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminExternalProjectManagersService.AdminExternalProjectManagersControllerApplyGeruestrechnerBackfillPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminExternalProjectManagerBackfillResultDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminExternalProjectManagersControllerApplyGeruestrechnerBackfill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminExternalProjectManagersControllerApplyGeruestrechnerBackfill(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminExternalProjectManagerBackfillResultDto> {
    return this.adminExternalProjectManagersControllerApplyGeruestrechnerBackfill$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminExternalProjectManagerBackfillResultDto>): WorkAdminExternalProjectManagerBackfillResultDto => r.body)
    );
  }

}
